import StandardEvent from './StandardEvent';
export class FacebookStandardEvents {
    addPaymentInfo() {
        return new StandardEvent('AddPaymentInfo');
    }
    addToCart() {
        return new StandardEvent('AddToCart');
    }
    addToWishList() {
        return new StandardEvent('AddToWishList');
    }
    completedRegistration() {
        return new StandardEvent('CompleteRegistration');
    }
    contact() {
        return new StandardEvent('Contact');
    }
    customizeProduct() {
        return new StandardEvent('CustomizeProduct');
    }
    donate() {
        return new StandardEvent('Donate');
    }
    findLocation() {
        return new StandardEvent('FindLocation');
    }
    initiateCheckout() {
        return new StandardEvent('InitiateCheckout');
    }
    lead() {
        return new StandardEvent('Lead');
    }
    pageView() {
        return new StandardEvent('PageView');
    }
    purchase() {
        return new StandardEvent('Purchase');
    }
    schedule() {
        return new StandardEvent('Schedule');
    }
    search() {
        return new StandardEvent('Search');
    }
    startTrial() {
        return new StandardEvent('StartTrial');
    }
    submitApplication() {
        return new StandardEvent('SubmitApplication');
    }
    subscribe() {
        return new StandardEvent('Subscribe');
    }
    viewContent() {
        return new StandardEvent('ViewContent');
    }
}
//# sourceMappingURL=StandardEvents.js.map